var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-accounting-stock"),
                  _c("app-stock-scanner"),
                  _vm.hasSizeModule
                    ? _c("app-size-table-settings", { staticClass: "mt" })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("stock-locations"))),
                      ]),
                      _c(
                        "w-list",
                        [
                          _c(
                            "w-list-item",
                            [
                              _c("w-list-item-text", [
                                _c("b", [_vm._v(_vm._s(_vm.$ct("location")))]),
                              ]),
                              _c("w-list-item-text", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$ct("stock-location-name"))
                                  ),
                                ]),
                              ]),
                              _c(
                                "w-list-item-action",
                                { staticClass: "fake-button" },
                                [
                                  _c(
                                    "w-button",
                                    [_c("w-fa", { attrs: { icon: "pen" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(_vm.locationIDs, function (i) {
                            return _c(
                              "w-list-item",
                              { key: i },
                              [
                                _c("w-list-item-text", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$tc("common.stock-location", i)
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("w-list-item-text", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.config.getLocationName(i)) +
                                      " "
                                  ),
                                ]),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct(
                                              "edit-stock-location"
                                            ),
                                            expression:
                                              "$ct('edit-stock-location')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.editLocation(i)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "pen" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditLocationID != 0 } },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "700" } },
            [
              _c("w-card-title", [
                _vm._v(
                  _vm._s(_vm.$tc("common.stock-location", _vm.toEditLocationID))
                ),
              ]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("stock-location-name"),
                            },
                            model: {
                              value: _vm.toEditAlias,
                              callback: function ($$v) {
                                _vm.toEditAlias = $$v
                              },
                              expression: "toEditAlias",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("disable-overwrite-stock"),
                            },
                            model: {
                              value:
                                _vm.toEditSettings
                                  .DisableOverwriteStockToNewBookYear,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.toEditSettings,
                                  "DisableOverwriteStockToNewBookYear",
                                  $$v
                                )
                              },
                              expression:
                                "toEditSettings.DisableOverwriteStockToNewBookYear",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct(
                                "enabled-by-default-for-inventory-report"
                              ),
                            },
                            model: {
                              value:
                                _vm.toEditSettings
                                  .EnabledByDefaultForInventoryReport,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.toEditSettings,
                                  "EnabledByDefaultForInventoryReport",
                                  $$v
                                )
                              },
                              expression:
                                "toEditSettings.EnabledByDefaultForInventoryReport",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        _vm._l(
                          _vm.addToAutomaticOrderSupplierOptions,
                          function (option) {
                            return _c("w-radio", {
                              key: option.value,
                              attrs: {
                                checked:
                                  _vm.toEditSettings
                                    .AddToAutomaticOrderToSupplier ==
                                  option.value,
                                label: option.text,
                              },
                              on: {
                                input: function ($event) {
                                  _vm.toEditSettings.AddToAutomaticOrderToSupplier =
                                    option.value
                                },
                              },
                            })
                          }
                        ),
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("add-to-total-stock") },
                            model: {
                              value: _vm.toEditSettings.AddToTotalStock,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.toEditSettings,
                                  "AddToTotalStock",
                                  $$v
                                )
                              },
                              expression: "toEditSettings.AddToTotalStock",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { icon: "ban" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelEdit()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: !_vm.saveEnabled, icon: "save" },
                      on: {
                        click: function ($event) {
                          return _vm.saveEdit()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }